// columnsNum // 几级联动，2，3
// defaultValue // 默认值，必须是Number
<template name="myAddressCascade">
	<van-popup v-model="isAddress" position="bottom" @click-overlay="onCancel">
		<van-area :columns-num="columnsNum" :area-list="addressList" @cancel="onCancel" @confirm="onConfirm"
			:value="defaultValue ? defaultValue.toString() : '110101'" />
	</van-popup>
</template>

<script>
	import {
		getareafindall
	} from '@/api/common'
	export default {
		props: {
			columnsNum: Number,
			defaultValue: Number // 默认值
		},
		name: 'myAddressCascade',
		data() {
			return {
				isAddress: true,
				addressList: {}
			}
		},
		created() {
			this.getData()
		},
		methods: {
			getData() {
				getareafindall().then(res => { // 获取省市区接口
					let arrData = []
					let myAddressObj = {
						province_list: {},
						city_list: {},
						county_list: {}
					}
					res.data.forEach(item => {
						if (item.parent === 0) {
							arrData.push({
								...item,
								children: []
							})
							myAddressObj.province_list[item.value] = item.name
						}
						arrData.forEach(it => {
							if (this.columnsNum === 2) {
								if (it.value === item.parent) {
									it.children.push({
										...item,
										children: []
									})
									myAddressObj.city_list[item.value] = item.name !== '市辖区' ? item
										.name : myAddressObj.province_list[item.parent]
								}
							} else {
								if (it.value === item.parent) {
									it.children.push({
										...item,
										children: []
									})
									myAddressObj.city_list[item.value] = item.name
								}
								it.children.forEach(val => {
									if (val.value === item.parent) {
										val.children.push({
											...item
										})
										myAddressObj.county_list[item.value] = item.name
									}
								})
							}
						})
					})
					this.addressList = myAddressObj
				})
			},
			// 选择地址
			onConfirm(e) {
				let obj = {
					address: [],
					code: []
				}
				e && e.forEach(item => {
					obj.address.push(item.name)
					obj.code.push(item.code)
				})
				this.$emit('addressCallback', obj, 1)
			},
			onCancel() {
				this.isAddress = false
				// this.$emit('addressCallback', null, 2)
			}
		}
	}
</script>
<style></style>
